import { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Search } from '@mui/icons-material'
import { useTheme } from '@mui/system'
import { Form, Formik } from 'formik'
import InputField from 'components/atoms/fields/InputField'
import { ELEMENT_RADIUS_MID } from 'utils/customizedTheme'
import { debounce } from 'lodash'
import { useGET_studentsQuery } from 'redux/api/studentsApi'
import { translateGradeLevel } from 'utils/helpers'
import { Link } from '@mui/material'

const SearchBar = ({ border }) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const navigate = useNavigate()

  const [search, setSearch] = useState('') 
  const [open, setOpen] = useState(false) 
  const [delay, setDelay] = useState(null) 

  const { data } = useGET_studentsQuery({page_size: 10, search: search}, {skip: !search})
  
  const setFilter = useCallback(
    debounce((value) => {
      setSearch(value)
    }, 500),
    [],
  )
  
  useEffect(() => {        
      if(data?.results.length > 0){
        setOpen(true)
        const timeout = setTimeout(()=>{
          setOpen(false)
        }, 5000)
        setDelay(timeout)
      }else{
        setOpen(false)
      }
  }, [data?.results]) 

    
  return (
    <Formik 
      initialValues={{ search: '' }} 
      validationSchema={null} 
      onSubmit={(values)=>{
        setTimeout(() => {
          navigate(`/students/?search=${values.search}&page=${1}`)
        },500)
      }}>
      <Form style={{ display: 'flex', alignItems: 'center', width: '100%', position: 'relative' }}>
        <InputField
          fieldProps={{ label: '', name: 'search' }}
          placeholder={t('common.main-search')}
          icon={<Search color='primary' sx={{ mr: 1, my: 0.5 }} />}
          onChange={(newValue) => {
            setFilter(newValue)
          }}
          sx={{
            paddingBottom: '0',
            width: '100%',
            background: theme.palette.background.default,
            '& fieldset': { borderColor: border ? border : null, borderRadius: ELEMENT_RADIUS_MID },
          }}
        />
        {data && data.results && data.results.length> 0 && open &&
        <div 
          onMouseEnter={(e) => {
            if(delay)
                clearTimeout(delay)
            }}
          onMouseLeave={(e) => {
            if(delay)
              clearTimeout(delay)
            const timeout = setTimeout(()=>{
              setOpen(false)
            }, 2000)
            setDelay(timeout)
          }} 
          style={{ 
            position: 'absolute', 
            zIndex: 1,
            top: '46px', 
            left: '6px', 
            background: '#fff', 
            border: '1px solid #ccc', 
            borderBottom: 'none' }}>
          {data.results.map(s => <div key={s.id} style={{ padding: '5px', borderBottom: '1px solid #ccc'}}>
             <Link onClick={() =>{
                if(delay)
                  clearTimeout(delay)
                setOpen(false)
                navigate(`/students/view/${s.id}`)
               }} sx={{ 
                cursor: 'pointer',
                color: '#333', 
                fontSize: '12px', 
                '&:hover': {textDecoration: 'underline'}
              }}>
             {s.full_name}, {translateGradeLevel(s.grade_level)}
            </Link>
          </div>)}
        </div>
        }
      </Form>
    </Formik>
  )
}

export default SearchBar
